import { BookingAddressType } from 'generated/graphql'
import { ConsignmentPair } from 'hooks/booking/useBookingAddresses'
import { AddressEta } from 'hooks/useAllAddressesEta'

import { DeliveredTrackingSection } from './DeliveredTrackingSection'
import { TrackingInfoSection } from './TrackingInfoSection'

interface TrackingSectionContentProps {
  isDelivered: boolean
  bookingData: any
  bookingCurrentAction: any
  nextBookingAction: any
  consignmentPairs?: ConsignmentPair[]
  deliveryCompletedAt?: string
  isMobile?: boolean
  nextAddressEta?: string | null
  etaWindowMinutes?: number | null
  etaLoading?: boolean
  onDetailsClick: () => void
  onProofOfDeliveryClick?: () => void
  onProofOfCollectionClick?: () => void
  onCombinedDocsClick?: () => void
  referenceAddressType?: BookingAddressType | null
  collectionAttachmentCount?: number
  deliveryAttachmentCount?: number
  combinedDocAttachmentCount?: number
  addressEtas?: AddressEta[]
  talkToAnExpertUrl: string
}

export const TrackingSectionContent = ({
  isDelivered,
  bookingData,
  bookingCurrentAction,
  nextBookingAction,
  consignmentPairs,
  deliveryCompletedAt,
  isMobile,
  nextAddressEta,
  etaWindowMinutes,
  etaLoading,
  onDetailsClick,
  onProofOfDeliveryClick,
  onProofOfCollectionClick,
  onCombinedDocsClick,
  referenceAddressType,
  collectionAttachmentCount,
  deliveryAttachmentCount,
  combinedDocAttachmentCount,
  addressEtas,
  talkToAnExpertUrl,
}: TrackingSectionContentProps) => {
  return isDelivered ? (
    <DeliveredTrackingSection
      booking={bookingData}
      talkToAnExpertUrl={talkToAnExpertUrl}
      bookingCurrentAction={bookingCurrentAction}
      nextBookingAction={nextBookingAction}
      deliveryTime={deliveryCompletedAt}
      onDetailsClick={onDetailsClick}
      onProofOfDeliveryClick={onProofOfDeliveryClick}
      onProofOfCollectionClick={onProofOfCollectionClick}
      onCombinedDocsClick={onCombinedDocsClick}
      referenceAddressType={referenceAddressType}
      collectionAttachmentCount={collectionAttachmentCount}
      deliveryAttachmentCount={deliveryAttachmentCount}
      combinedDocAttachmentCount={combinedDocAttachmentCount}
    />
  ) : (
    <TrackingInfoSection
      onDetailsClick={onDetailsClick}
      isMobile={isMobile}
      booking={bookingData}
      talkToAnExpertUrl={talkToAnExpertUrl}
      bookingCurrentAction={bookingCurrentAction}
      nextBookingAction={nextBookingAction}
      consignmentPairs={consignmentPairs}
      nextAddressEta={nextAddressEta}
      etaWindowMinutes={etaWindowMinutes}
      etaLoading={etaLoading}
      onProofOfDeliveryClick={onProofOfDeliveryClick}
      onProofOfCollectionClick={onProofOfCollectionClick}
      referenceAddressType={referenceAddressType}
      collectionAttachmentCount={collectionAttachmentCount}
      deliveryAttachmentCount={deliveryAttachmentCount}
      addressEtas={addressEtas}
    />
  )
}
